// extracted by mini-css-extract-plugin
module.exports = {"horizontalTable":"TransposableTable_horizontalTable__1aSbp","header":"TransposableTable_header__udGoi","verticalTable":"TransposableTable_verticalTable__x5rVD"};